export function filterMenuListByDisabledKeys(menuList, disabledKeys = []) {
  if (!Array.isArray(menuList) || !disabledKeys?.length) {
    return menuList;
  }

  const disabled = new Set(disabledKeys);

  const filtered = menuList
    .filter((item) => {
      if (item.classsChange === "menu-title") return true;
      return !disabled.has(item.menuKey);
    })
    .map((item) => {
      if (item.classsChange === "menu-title" || !item.content?.length) {
        return item;
      }

      const filteredContent = item.content.filter(
        (subItem) => !disabled.has(subItem.menuKey)
      );

      if (!filteredContent.length) {
        return null;
      }

      return { ...item, content: filteredContent };
    })
    .filter(Boolean);

  // Drop section titles that have no following items before the next title
  return filtered.filter((item, index) => {
    if (item.classsChange !== "menu-title") return true;
    const next = filtered.slice(index + 1).find((x) => x.classsChange === "menu-title" || x.menuKey);
    return next && next.classsChange !== "menu-title";
  });
}
